import moment from 'moment';

export const isReportRangeLongerThanMonth = (from, to) => {
	const fromDate = moment(from).startOf('day');
	const toDate = moment(to).startOf('day');

	return toDate.isAfter(fromDate.clone().add(1, 'month'));
};
